// src/services/titleRatingService.js
// Aluvo star ratings (docs/movie-ratings.md). The movie detail response
// already carries { aluvoRating, myRating }, so the page only calls these to
// write. Values are stars (0.5 … 5); every write returns the fresh aggregate.
import { apiRequest } from './api';

const path = (kind, tmdbId) => `/title-ratings/${kind}/${tmdbId}`;

export const TitleRatingService = {
    /** { aluvoRating, myRating } — myRating is null for guests. */
    get(kind, tmdbId) {
        return apiRequest(path(kind, tmdbId));
    },

    /** Create or update. → { myRating, created, aluvoRating } */
    rate(kind, tmdbId, rating) {
        return apiRequest(`${path(kind, tmdbId)}/me`, { method: 'PUT', body: { rating } });
    },

    /** Idempotent. → { myRating: null, removed, aluvoRating } */
    remove(kind, tmdbId) {
        return apiRequest(`${path(kind, tmdbId)}/me`, { method: 'DELETE' });
    },

    /** Own rated movies. → { sort, items, nextCursor, hasMore } (sort: recent | highest | lowest) */
    myHistory({ sort, limit, cursor } = {}) {
        return apiRequest('/title-ratings/me', { params: { sort, limit, cursor } });
    },

    /** Another user's rated movies, gated by their profile visibility.
     *  → { user, isPrivate, sort, items, nextCursor, hasMore } */
    userHistory(username, { sort, limit, cursor } = {}) {
        return apiRequest(`/users/${encodeURIComponent(username)}/ratings`, { params: { sort, limit, cursor } });
    },
};

/** Inline copy for a failed write. */
export function ratingErrorMessage(err, action = 'save') {
    if (err?.isNetworkError) return err.message;
    if (err?.statusCode === 429 && err.message) return err.message;
    if (err?.statusCode === 403) return 'Add your date of birth to rate movies.';
    return action === 'remove' ? "Couldn't remove your rating. Try again." : "Couldn't save your rating. Try again.";
}
